module.exports = __webpack_public_path__ + "static/media/portfolio1 (32).3b36d553.jpeg";